import React from 'react'

const Loading = () => {
    return(
        <div>
            <img src="/images/loading.gif" alt="loading" style={{ maxWidth: '450px', width: '100%' }} />
        </div>
    )
}

export default Loading